export default __webpack_public_path__ + "static/media/Account.1a48836f.png";